import { api } from './api';
import { LoginRequest, LoginResponse, User } from '../types';

export const authService = {
  // Login
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    // Apuntar a la ruta real de Django: /api/v1/auth/users/login/
    const response = await api.post<any>('/auth/users/login/', credentials);
    
    // El backend de CreaSync envuelve los tokens y datos dentro de un objeto "data"
    const { access, refresh, user } = response.data.data;

    // Almacenar tokens
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    localStorage.setItem('user', JSON.stringify(user));

    return response.data.data;
  },

  // Logout
  logout: (): void => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },

  // Get current user
  getCurrentUser: async (): Promise<User> => {
    // Apuntar a la ruta real de Django: /api/v1/auth/users/me/
    const response = await api.get<any>('/auth/users/me/');
    const userData = response.data.data;
    
    localStorage.setItem('user', JSON.stringify(userData));
    return userData;
  },

  // Refresh token
  refreshToken: async (): Promise<string> => {
    const refresh = localStorage.getItem('refresh_token');
    if (!refresh) {
      throw new Error('No refresh token available');
    }

    const response = await api.post<{ access: string }>('/auth/token/refresh/', { refresh });
    const { access } = response.data;
    localStorage.setItem('access_token', access);
    return access;
  },

  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('access_token');
  },

  // Get stored user
  getStoredUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  },
};
